import { sdkRequest } from '@eventbrite/http';
import { formatUrl } from 'url-lib';

const USER_TAGS_URL = '/api/v3/destination/users/me/tags/';
const USER_SAVE_TAGS_URL = `${USER_TAGS_URL}save/`;
const USER_UNSAVE_TAGS_URL = `${USER_TAGS_URL}unsave/`;

type Tag = { action_performed: boolean; tag: string; saved_by_you: boolean };

export interface GetSavedTagsResponse {
    tags: Tag[];
}

/**
 * @name savedTags
 * @returns {object} saved tags associated with the logged in user
 */
export const savedTags = (): Promise<GetSavedTagsResponse> =>
    sdkRequest(formatUrl(USER_TAGS_URL));

/**
 * @name toggleInterest
 * @param tagId {string}
 * @param saved {boolean}
 * @returns {object} action success and saved state
 */
export const toggleInterest = (tagId: string, saved: boolean) =>
    sdkRequest(saved ? USER_UNSAVE_TAGS_URL : USER_SAVE_TAGS_URL, {
        method: 'POST',
        body: JSON.stringify({
            tags: [tagId],
        }),
    });
